import React from 'react';

import { Dropdown as SemanticDropDown, DropdownProps } from 'semantic-ui-react';

import styled from 'styled-components';

const DropdownWrapper = styled.div`
  position: relative;
  z-index: 20;

  .ui.dropdown {
    /* background-color: #F5F8FA !important; */
  }

  .ui.dropdown .menu {
    z-index: 10050 !important;
  }

  .ui.active.dropdown,
  .ui.dropdown.active {
    z-index: 10050 !important;
  }

  .disabled.dropdown {
    background-color: #F5F8FA !important;
    opacity: 1 !important;
  }
`;

const StatusDropdown = (data: DropdownProps) => {
  const { form } = data;
  const { setFieldTouched } = form;
  const { defaultValue, value, upward, ...dropdownProps } = data;

  return (
    <>
      <DropdownWrapper>
        <SemanticDropDown
          {...dropdownProps.field}
          {...dropdownProps}
          value={dropdownProps.field.value}
          button
          className="icon"
          floating
          upward={upward !== false}
          color={'blue'}
          onBlur={(e, { value }) => {
            setFieldTouched(data.field.name, true, true);
          }}
        />
      </DropdownWrapper>
    </>
  );
};

export default StatusDropdown;
